import { TermsDetails } from '@api/api.types'
import { FlowCardLoading } from '@components/FlowCard'
import {
  userTermsQueryOptions,
  walletTermsQueryOptions,
} from '@src/queryOptions/terms'
import { cardProgramQueryOptions } from '@src/queryOptions/users'
import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'

import { termsSearchSchema } from '../-searchSchemas/lib/terms'

export const Route = createFileRoute('/_initialized/terms')({
  validateSearch: termsSearchSchema,
  loaderDeps: ({ search: { agreementType, pageNumber } }) => ({
    agreementType,
    pageNumber,
  }),
  loader: async ({
    deps: { agreementType, pageNumber },
    context: { queryClient, store },
  }) => {
    const { essentialFlow } = store.getState().onboarding

    let terms: TermsDetails[]
    switch (agreementType) {
      case 'user': {
        terms = await queryClient.ensureQueryData(userTermsQueryOptions)
        break
      }
      case 'wallet':
        const [walletTerms] = await Promise.all([
          queryClient.ensureQueryData(
            walletTermsQueryOptions({
              isPayCardAccount: essentialFlow,
            })
          ),
          queryClient.ensureQueryData(cardProgramQueryOptions),
        ])
        terms = walletTerms
    }

    const allTermsAreInline = terms.every(term => term.display_inline)
    if (allTermsAreInline && !pageNumber) {
      redirect({
        to: '/terms',
        search: { pageNumber: 1, agreementType },
        throw: true,
      })
    }
  },
  pendingComponent: FlowCardLoading,
})
